import React from "react";

export default function ArrowRight() {
  return (
    <svg
      className="text--carousel__options-item-arrow"
      width="34"
      height="25"
      viewBox="0 0 34 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 24.696C21 22.68 21.368 20.824 22.104 19.128C22.84 17.4 23.832 16.04 25.08 15.048C26.36 14.056 27.736 13.56 29.208 13.56V11.352C27.736 11.352 26.36 10.856 25.08 9.864C23.832 8.872 22.84 7.528 22.104 5.832C21.368 4.104 21 2.232 21 0.215999H24.264C24.264 2.168 24.68 3.96 25.512 5.592C26.344 7.192 27.48 8.472 28.92 9.432C30.36 10.392 31.928 10.872 33.624 10.872V14.04C31.928 14.04 30.36 14.52 28.92 15.48C27.48 16.44 26.344 17.736 25.512 19.368C24.68 20.968 24.264 22.744 24.264 24.696H21ZM0.84 10.872H32.088V14.04H0.84V10.872Z"
        fill="#123333"
      />
    </svg>
  );
}
